import { Injectable } from '@angular/core';
import {Observable} from "rxjs";
import {StockByProductResponse, StockCreateRequest, StockResponse, StocksMetric} from "./model";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {environment} from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class StockService {

  constructor(
    public http: HttpClient,
  ) { }

  getStocks(): Observable<StockResponse[]> {
    return this.http.get<StockResponse[]>(environment.apiUrl + "/stocks");
  }

  getStocksByProduct(): Observable<StockByProductResponse[]> {
    return this.http.get<StockByProductResponse[]>(environment.apiUrl + "/stocks/products")
  }
  
  getStockMetric(): Observable<StocksMetric> {
    return this.http.get<StocksMetric>(environment.apiUrl + "/stocks/metrics/");
  }

  getStocksByItemID(itemId: number): Observable<StockResponse[]> {
    return this.http.get<StockResponse[]>(environment.apiUrl + "/stocks/" + itemId);
  }

  addStockTransaction(body: StockCreateRequest): Observable<StockCreateRequest> {
    const token = localStorage.getItem('access_token');
    const headers = new HttpHeaders({
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    });
    return this.http.post<StockCreateRequest>(environment.apiUrl + "/stocks", body, { headers });
  }
}
